import React, { useState } from 'react';
import { CardProgressWrapper } from '@/components/ui/card';
import { StudyGuideDiagnosticModal } from './study-guide-diagnostic-modal';
import moment from 'moment';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { cn } from '@/lib/utils';

export function StudyGuideDiagnosticDataGrid(props) {
  const { data, height = 'auto' } = props;
  const playful = usePlayfulStudent();

  const [selectedQuestionBookUserId, setSelectedQuestionBookUserId] = useState(null);
  const [title, setTitle] = useState('');

  const handleShowModal = (question_book_user_id, title) => {
    setSelectedQuestionBookUserId(question_book_user_id);
    setTitle(title);
  };

  return (
    <div
      className={cn('overflow-y-auto', playful && 'overflow-x-hidden rounded-2xl border border-neutral-lightest')}
      style={{ height: height }}
    >
      <Table className="min-w-[688px]">
        <TableHeader className={cn(playful && 'bg-[var(--color-bg-lilac)]')}>
          <TableRow>
            <TableHead scope="col">Prova diagnóstica</TableHead>
            <TableHead scope="col">Data da prova</TableHead>
            <TableHead scope="col">Maior rendimento em</TableHead>
            <TableHead scope="col">Menor rendimento em</TableHead>
            <TableHead scope="col">Acerto geral</TableHead>
            <TableHead
              scope="col"
              className="w-[128px]"
            />
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.map((item, key) => (
            <TableRow key={key}>
              <TableHead scope="row">
                <span className="truncate">{item.title}</span>
              </TableHead>
              <TableCell>
                <span className="truncate">{moment(item.finished_at).format('DD/MM/YYYY')}</span>
              </TableCell>
              <TableCell>
                <span className="truncate">{item.highest_score.name}</span>
              </TableCell>
              <TableCell>
                <span className="truncate">{item.lowest_score.name}</span>
              </TableCell>
              <TableCell>
                <CardProgressWrapper
                  percentage={parseFloat(item.answer_percentage)}
                  toFixed={0}
                />
              </TableCell>
              <TableCell>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button
                      variant="link"
                      size="sm"
                      fullWidth
                      onClick={() => handleShowModal(item.question_book_user_id, item.title)}
                    >
                      Mais detalhes
                    </Button>
                  </DialogTrigger>

                  <StudyGuideDiagnosticModal
                    question_book_user_id={selectedQuestionBookUserId}
                    title={title}
                  />
                </Dialog>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
